
/* Controller Imports */
import AlertsCreateController from './create/create.controller';
import AlertsListController from './list/list.controller';                        
import AlertsViewDeleteController from './delete-modal/delete.controller';            
import AlertsViewEditController from './view/details/view.controller';             
import AlertsViewPickAssetsController from './view/assets/assets.controller';           
import AlertsViewTriggersControllerCRUD from './view/triggers/triggers.controller';    

const alertsConfigModule = angular.module('app.configAlerts', [
    "ui.bootstrap",
    "ui.router",
    "gettext" 
])
/* Controllers */
.controller('AlertsCreateController', AlertsCreateController)
.controller('AlertsListController', AlertsListController)
.controller('AlertsViewDeleteController', AlertsViewDeleteController)
.controller('AlertsViewEditController', AlertsViewEditController)
.controller('AlertsViewPickAssetsController', AlertsViewPickAssetsController)
.controller('AlertsViewTriggersControllerCRUD', AlertsViewTriggersControllerCRUD);

export default alertsConfigModule.name;